import { filterControlsItalian } from "./filterControls";
import { askItalian } from "./ask";
import { italian as settingsItalian } from "./settings/italian";
import type { ClankTranslation } from "./shared";
import { italian as tourItalian } from "./tour/italian";
import { italian as watchlistItalian } from "./watchlist/italian";

export const italian = {
  process_details: "Dettagli del processo",
  session_details: "Dettagli della sessione",
  interactive_chat: "Chat interattiva",
  page_error: "Errore",
  askPanel: askItalian,
  filterControls: filterControlsItalian,
  Settings: "Impostazioni",
  web_service_limited_functionality_banner:
    "Questo servizio web non include tutte le funzionalità di Platonic. Per mappare il <strong>tuo</strong> lavoro, usa l'app desktop di Platonic.",
  static_demo_limited_functionality_banner:
    "Questa demo è una rappresentazione semplificata del nostro prodotto. Nessuna funzionalità è persistente e tutti i dati sono sintetici. Contattaci per il prodotto reale.",
  download_platonic_desktop: "Scarica Platonic desktop",
  downloads_page: "Download",
  downloads_page_description:
    "Scarica l'installer dell'applicazione desktop di Platonic per il tuo sistema operativo.",
  downloads_registered_users_only_title: "I download sono riservati agli utenti registrati",
  downloads_registered_users_only_message:
    "L'installer dell'app desktop di Platonic è disponibile dopo l'onboarding. Contattaci e ti aiuteremo ad attivare l'accesso per la tua azienda.",
  contact_us_for_onboarding: "Contattaci",
  downloads_load_failed: "Impossibile caricare i download",
  no_downloads_available_for_os: "Nessun download disponibile al momento per {{os}}.",
  operating_systems: "Sistemi operativi",
  windows: "Windows",
  macos: "macOS",
  linux: "Linux",
  released: "Rilasciato",
  download: "Scarica",
  executive_dashboard: "Amministrazione",
  processes: "Processi",
  recordings: "Sessioni",
  close: "Chiudi",
  cancel: "Annulla",
  or: "oppure",
  submit: "Invia",
  save: "Salva",
  loading: "Caricamento",
  loading_ellipsis: "Caricamento…",
  generating_graph: "Generazione del grafo…",
  regenerating_graph: "Rigenerazione del grafo…",
  graph_layout_failed: "Non è stato possibile disporre il grafo. Ricarica la pagina per riprovare.",
  loading_app: "Caricamento applicazione...",
  user: "Utente",
  source: "Origine",
  what_platonic_records: "Cosa cattura Platonic",
  capture_privacy_summary:
    "Platonic cattura screenshot periodici, eventi di clic e scorrimento, scorciatoie da tastiera e tasti speciali (come Enter, Tab o Cmd+C) e il titolo della finestra attiva per comprendere i passaggi del tuo flusso di lavoro.",
  no_typed_content: "Nessun contenuto digitato",
  no_typed_content_detail: "Platonic non cattura il testo effettivo che digiti.",
  no_continuous_recording: "Nessuna registrazione continua dello schermo",
  no_continuous_recording_detail:
    "Platonic salva singoli screenshot, non un video del tuo schermo.",
  no_audio_or_microphone: "Niente audio o microfono",
  no_camera_access: "Nessun accesso alla fotocamera",
  language: "Lingua",
  context: "Contesto",
  execution_mode: "Modalità di esecuzione",
  start_recording: "Mappa il mio lavoro",
  recording: "Mappatura",
  paused: "In pausa",
  stopping_recording: "Arresto mappatura",
  syncing: "Sincronizzazione...",
  unable_to_load_recordings: "Impossibile caricare le sessioni",
  recordings_update_failed:
    "Impossibile aggiornare le sessioni; l'elenco potrebbe non essere aggiornato.",
  unable_to_check_updates: "Impossibile controllare gli aggiornamenti",
  api_version_mismatch_title: "Le versioni di Platonic non coincidono",
  api_version_mismatch_remote_newer: "più nuova",
  api_version_mismatch_remote_older: "più vecchia",
  api_version_mismatch_remote_different: "diversa",
  api_version_mismatch_message:
    "Il server remoto ha una versione {{relation}} rispetto a questa app (server {{remoteVersion}}, locale {{localVersion}}). Il download automatico dell'aggiornamento è in corso; alcune funzionalità potrebbero non funzionare fino all'applicazione dell'aggiornamento.",
  update_failed: "Aggiornamento fallito",
  analysis_failed: "Analisi fallita",
  run_failed: "Esecuzione fallita",
  failed_to_load_details_for_one_recording: "Impossibile caricare i dettagli per 1 sessione.",
  recording_permissions: "Permessi di registrazione",
  recording_permissions_ready_description: "Tutti i permessi per la registrazione sono concessi.",
  recording_permissions_modal_description:
    "Controlla i permessi di sistema necessari a Platonic prima della registrazione.",
  recording_permissions_recommended_description:
    "La registrazione funziona, ma attivando le impostazioni consigliate le registrazioni saranno più dettagliate.",
  recording_permissions_restart_title: "È necessario uscire e riaprire Platonic",
  recording_permissions_restart_app:
    "Dopo aver modificato Accessibilità o altri permessi di registrazione, esci completamente da Platonic e riaprilo.",
  recording_permissions_load_failed: "Impossibile caricare i permessi di registrazione",
  recording_permissions_check_again: "Controlla di nuovo",
  permission_status_granted: "Concesso",
  permission_required_for_recording: "Permesso richiesto",
  review_recording_permissions: "Controlla permessi",
  set_recording_permissions: "Imposta permessi di registrazione",
  request_permission: "Richiedi",
  open_system_settings: "Impostazioni",
  turn_on_permission: "Attiva",
  accessibility_permission: "Accessibilità",
  input_monitoring_permission: "Monitoraggio input",
  input_monitoring_blocked_description:
    "La cattura dell'input è bloccata da macOS. Di solito succede quando Platonic è stato negato esplicitamente in Monitoraggio input. Apri Impostazioni di Sistema > Privacy e sicurezza > Monitoraggio input e rimuovi o abilita Platonic, poi riavvia Platonic.",
  screen_and_system_audio_recording_permission: "Schermo e audio di sistema",
  desktop_accessibility_permission: "Accessibilità del desktop",
  desktop_accessibility_description:
    "Permette a Platonic di registrare i nomi dei pulsanti e dei campi che usi. Le app già aperte quando lo attivi devono essere riavviate per essere incluse.",
  settings: settingsItalian,
  finalizing_recording: "Elaborazione della registrazione",
  redacting_screenshots: "Oscuramento degli screenshot rimanenti prima del caricamento",
  saved: "risparmiati",
  lost: "persi",
  latest: "Ultima",
  step: "passaggio",
  steps: "steps",
  n_steps: "{{count}} passaggi",
  n_steps_one: "{{count}} passaggio",
  instances: "casi",
  instances_unit: "casi",
  all_instances: "Tutti i casi",
  all_n_instances: "Tutti i {{count}} casi",
  all_n_instances_one: "{{count}} caso",
  n_recordings: "{{count}} sessioni",
  n_recordings_one: "{{count}} sessione",
  selected_n_of_total_instances: '{{count}} di $t(n_instances, {"count": {{total}} }) selezionati',
  selected_n_of_total_instances_one:
    '{{count}} di $t(n_instances, {"count": {{total}} }) selezionato',
  filter_action: "Filtra",
  filtering_instances: "Selezione dei casi corrispondenti...",
  filter_failed: "Il filtro dei casi non è riuscito. Riprova.",
  describe_instances_you_want: "Filtra i casi in linguaggio naturale...",
  no_instances_match_condition: "Nessun risultato per questa condizione.",
  filter_instances: "Filtra casi",
  no_matching_steps: "Nessun passaggio corrispondente.",
  remove_filter: "Rimuovi il filtro {{label}}",
  scope_filter_query: "Descrizione",
  scope_filter_user: "Utente",
  scope_filter_date: "Data",
  scope_filter_node: "Passaggio",
  scope_date_from: "dal {{date}}",
  scope_date_until: "fino al {{date}}",
  scope_through_node: "tramite {{name}}",
  scope_hand_picked: "scelti a mano",
  last_n_days: "Ultimi {{count}} giorni",
  last_n_days_one: "Ultimo {{count}} giorno",
  scope_date_any: "Seleziona data",
  scope_date_dots_legend: "Casi di questo processo iniziati quel giorno",
  scope_filter_done: "Fatto",
  scope_filter_apply: "Applica",
  previous_month: "Mese precedente",
  next_month: "Mese successivo",
  no_instances_match_scope: "Nessun caso corrisponde a questo ambito.",
  scope_criteria_conflict: "{{criteria}} non possono essere entrambi veri.",
  scope_criteria_join: " e ",
  scope_matching_and_selected: "{{matched}} corrispondenti · {{included}} selezionati",
  scope_matching_all_selected: "{{matched}} corrispondenti · tutti selezionati",
  scope_all_instances: "Tutti i {{matched}} casi",
  scope_selected_of_all: "{{included}} di {{matched}} casi selezionati",
  close_filter_editor: "Chiudi filtro",
  scope_criterion_rules_out_everything: "{{criteria}} esclude ogni caso.",
  scope_label: "Ambito",
  expand_instances: "Espandi casi per",
  collapse_instances: "Comprimi casi per",
  succeeded: "Completato",
  failed: "Fallito",
  running: "In esecuzione",
  pending: "In attesa",
  cancelled: "Annullato",
  process: "Processo",
  analyze_now: "Analizza",
  analyzing_ellipsis: "Analisi in corso...",
  no_recordings_available: "Nessuna sessione disponibile.",
  loading_recordings: "Caricamento sessioni...",
  authentication_required: "Autenticazione richiesta",
  browser_login_wait_title: "Una scheda del browser è stata aperta",
  browser_login_wait_message:
    "Continua lì la procedura di accesso. Questa finestra proseguirà automaticamente quando l'accesso sarà completato.",
  browser_login_waiting_status: "In attesa dell'accesso...",
  browser_login_complete_status: "Accesso completato. Ritorno a Clank...",
  browser_login_done_title: "Procedura di accesso terminata",
  browser_login_done_message: "Puoi chiudere questa finestra e tornare all'app.",
  csrf_validation_failed_missing_header: "Validazione CSRF fallita: token mancante.",
  csrf_validation_failed_invalid_header: "Validazione CSRF fallita: token non valido.",
  login_again: "Accedi di nuovo",
  login_again_message:
    "Una richiesta remota al server ha restituito l'errore 'unauthenticated'. Si consiglia di effettuare nuovamente il login.",
  recent_recordings: "Sessioni recenti",
  recordings_click_to_view_full_analysis:
    "{{count}} sessioni acquisite · Clicca per vedere l'analisi completa",
  recordings_click_to_view_full_analysis_one:
    "{{count}} sessione acquisita · Clicca per vedere l'analisi completa",
  uploading_recording_data: "Caricamento dati sessione...",
  syncing_recording: "Sincronizzazione sessione",
  sync_failed: "Sincronizzazione fallita",
  no_analyzed_recordings_available_yet: "Nessuna sessione analizzata disponibile al momento.",
  recording_archived: "Archiviata",
  recording_active: "Attiva",
  current_user: "Tu",
  recording_filter_scope: "Mostra",
  recording_filter_all: "Tutte",
  rename_recording: "Rinomina",
  archive_recording: "Archivia",
  unarchive_recording: "Ripristina",
  archive_recording_tooltip:
    "Le sessioni archiviate restano disponibili con il filtro Archiviate o Tutte, ma sono escluse dalla panoramica e dalle metriche dei processi.",
  unarchive_recording_tooltip:
    "Ripristina questa sessione nell'elenco delle sessioni attive, nella panoramica e nelle metriche dei processi.",
  recording_archive_update_failed: "Impossibile aggiornare lo stato di archiviazione",
  archived_recordings_match_filters_one:
    "{{count}} sessione archiviata corrisponde ai tuoi filtri.",
  archived_recordings_match_filters: "{{count}} sessioni archiviate corrispondono ai tuoi filtri.",
  show_archived_recordings: "Mostra archiviate",
  select_recording: "Seleziona sessione",
  select_all_recordings_on_page: "Seleziona tutte in questa pagina",
  recordings_selected_one: "{{count}} sessione selezionata",
  recordings_selected: "{{count}} sessioni selezionate",
  clear_selection: "Annulla selezione",
  bulk_actions: "Azioni multiple",
  archive_selected_recordings: "Archivia selezionate",
  unarchive_selected_recordings: "Ripristina selezionate",
  delete_selected_recordings: "Elimina selezionate",
  bulk_archive_recordings_title_one: "Archiviare {{count}} sessione?",
  bulk_archive_recordings_title: "Archiviare {{count}} sessioni?",
  bulk_unarchive_recordings_title_one: "Ripristinare {{count}} sessione?",
  bulk_unarchive_recordings_title: "Ripristinare {{count}} sessioni?",
  bulk_delete_recordings_title_one: "Eliminare {{count}} sessione?",
  bulk_delete_recordings_title: "Eliminare {{count}} sessioni?",
  bulk_archive_recordings_message:
    "Queste sessioni resteranno disponibili con il filtro Archiviate o Tutte, ma saranno escluse dalla panoramica e dalle metriche dei processi.",
  bulk_unarchive_recordings_message:
    "Queste sessioni verranno ripristinate nell'elenco delle sessioni attive, nella panoramica e nelle metriche dei processi.",
  bulk_delete_recordings_message:
    "Le seguenti sessioni verranno rimosse dallo storage remoto e da Platonic. L'operazione non può essere annullata.",
  bulk_delete_analyzing_notice_one:
    "{{count}} sessione è ancora in fase di analisi e non verrà eliminata. Interrompi prima l'analisi se vuoi eliminarla.",
  bulk_delete_analyzing_notice:
    "{{count}} sessioni sono ancora in fase di analisi e non verranno eliminate. Interrompi prima le analisi se vuoi eliminarle.",
  bulk_recording_update_failed_one:
    "Impossibile aggiornare {{count}} sessione. Rimane selezionata per riprovare.",
  bulk_recording_update_failed:
    "Impossibile aggiornare {{count}} sessioni. Rimangono selezionate per riprovare.",
  bulk_recording_delete_failed_one:
    "Impossibile eliminare {{count}} sessione. Rimane selezionata per riprovare.",
  bulk_recording_delete_failed:
    "Impossibile eliminare {{count}} sessioni. Rimangono selezionate per riprovare.",
  delete_recording: "Elimina sessione",
  delete_recording_title: "Eliminare la sessione?",
  delete_recording_message: "Rimuove questa sessione. L'operazione non può essere annullata.",
  delete_recording_message_synced:
    "Rimuove questa sessione dallo storage remoto e da Platonic. L'operazione non può essere annullata.",
  delete_recording_message_local:
    "Rimuove questa sessione da questo computer. L'operazione non può essere annullata.",
  acknowledge_delete_recording: "Capisco che l'operazione non può essere annullata.",
  confirm_delete_recording: "Elimina definitivamente",
  recording_delete_failed: "Impossibile eliminare la sessione",
  recording_import: "Import sessione",
  recording_import_card_description:
    "Crea o sostituisci un'analisi di sessione da un risultato JSON validato.",
  import_recording_analysis: "Importa analisi sessione",
  edit_recording_analysis: "Modifica analisi sessione",
  recording_import_description:
    "Incolla un risultato di analisi completo in JSON. Platonic lo validerà e calcolerà le date della sessione.",
  failed_to_load_recording_import_data: "Impossibile caricare i dati per l'import della sessione",
  loading_recording_import_data: "Caricamento dati import sessione...",
  failed_to_save_recording_analysis: "Impossibile salvare l'analisi della sessione",
  you_do_not_have_permission_to_import_recordings:
    "Non hai i permessi per importare analisi di sessioni.",
  select_user_for_recording_import: "Seleziona l'utente a cui appartiene questa sessione.",
  recording_name: "Nome sessione",
  include_imported_recording_in_processes: "Includi questa sessione nella generazione processi",
  recording_import_no_existing_analysis:
    "Questa sessione non ha ancora un risultato di analisi completato. Incolla il JSON sostitutivo completo.",
  analysis_result_json: "JSON risultato analisi",
  analysis_result_json_help:
    "Incolla l'oggetto completo del risultato di analisi. Deve rispettare lo schema AnalyticsData del backend.",
  save_recording_analysis: "Salva analisi sessione",
  app_menu: "Menu",
  recording_deletion_started:
    "Eliminazione avviata. È un'operazione lunga: torna più tardi per controllare.",
  recording_deletion_already_in_progress:
    "Un'eliminazione è già in corso. Torna più tardi per controllare il completamento.",
  expand_sidebar: "Espandi barra laterale",
  go_back: "Indietro",
  go_forward: "Avanti",
  collapse_sidebar: "Comprimi barra laterale",
  resize_sidebar: "Trascina per ridimensionare · doppio clic per reimpostare",
  no_data: "Nessun dato",
  end_stream: "Fine stream",
  unknown: "sconosciuto",
  ended: "Terminato",
  refuse: "Rifiuta",
  initial_app_load_failed: "Errore durante il caricamento iniziale dell'applicazione",
  retry: "Riprova",
  created: "Creato",
  started: "Avviato",
  manual_interventions: "Interventi manuali",
  trigger_entity: "Entità trigger",
  extra_context: "Contesto extra",
  group: "Gruppo",
  thinking: "Sto pensando...",
  overview: "Panoramica",
  timeline: "Timeline",
  missing_analytics_identifier_in_url: "Identificatore analisi mancante nell'URL.",
  unable_to_load_recording_data: "Impossibile caricare i dati della sessione",
  loading_recording: "Caricamento sessione...",
  recording_not_found_title: "Sessione non trovata",
  recording_not_found_message: "Questa sessione non esiste o non hai i permessi per visualizzarla.",
  back_to_recordings: "Torna alle sessioni",
  analyzing_recording: "Analisi sessione...",
  stop_analysis: "Interrompi analisi",
  stopping_analysis: "Interruzione...",
  failed_to_stop_analysis: "Impossibile interrompere l'analisi",
  something_went_wrong_you_can_retry_the_analysis:
    "Qualcosa è andato storto. Puoi riprovare l'analisi.",
  this_recording_has_not_been_analyzed_yet: "Questa sessione non è stata ancora analizzata.",
  analysis_cancelled_page_message: "L'analisi è stata annullata. Puoi avviarla di nuovo.",
  recording_too_short: "Troppo breve",
  analysis_runs: "Esecuzioni dell'analisi",
  analysis_run_pill_label: "Esecuzione analisi",
  analysis_run_latest: "piu recente",
  rerun_analysis: "Riesegui l'analisi",
  rerunning_ellipsis: "Riesecuzione in corso...",
  rerun_failed: "Riesecuzione non riuscita",
  rerun_progress_title: "Rianalisi in corso",
  rerun_progress_message:
    "La sessione continua a mostrare il risultato precedente finche questa esecuzione non termina.",
  rerun_progress_waiting: "In attesa dell'avanzamento dell'analisi...",
  view_rerun_progress: "Mostra l'avanzamento della rianalisi",
  rename_analysis_run: "Rinomina esecuzione",
  analysis_run_rename_message:
    "Dai un nome a questa esecuzione per distinguerla dalle altre della sessione.",
  analysis_run_name_placeholder: "Dai un nome a questa esecuzione",
  analysis_run_rename_failed: "Impossibile rinominare l'esecuzione dell'analisi",
  delete_analysis_run: "Elimina esecuzione",
  delete_analysis_run_message:
    "Viene eliminata solo questa esecuzione. La sessione e le altre esecuzioni restano.",
  delete_last_analysis_run_message:
    "Questa e l'unica analisi della sessione. La sessione resta e risultera non analizzata finche non riesegui l'analisi.",
  analysis_run_delete_failed: "Impossibile eliminare l'esecuzione dell'analisi",
  compare_analysis_runs: "Confronta le esecuzioni",
  compare_with_run_unavailable: "Un'esecuzione non riuscita non ha un risultato da confrontare",
  compare_run_on_other_band: "Già mostrata nell'altra sezione",
  compare_pick_two_runs: "Seleziona due esecuzioni da confrontare",
  compare_run_band: "Esecuzione {{side}}: {{name}}",
  change_run: "Cambia esecuzione",
  compare_run_load_failed: "Impossibile caricare l'esecuzione confrontata",
  rerun_from_run: "Riesegui da questa esecuzione",
  rerun_from_run_named: "Riesegui dall'esecuzione «{{name}}»",
  rerun_from_run_unavailable: "Questa esecuzione non ha conservato artefatti da cui ripartire",
  rerun_from_run_message:
    "Le fasi precedenti a quella scelta vengono copiate da questa esecuzione.",
  analysis_rerun_failed: "Impossibile avviare la riesecuzione dell'analisi",
  rerun_selected_recordings: "Riesegui l'analisi sulla selezione",
  rerun_recordings_title: "Riesegui l'analisi",
  rerun_recordings_message:
    "Ogni sessione selezionata viene analizzata di nuovo. I risultati attuali restano visibili finche una riesecuzione non termina.",
  recording_too_short_page_message:
    "Servono almeno 60 secondi di attività per analizzare una sessione.",
  retry_analysis: "Riprova analisi",
  view_analysis: "Vedi analisi",
  analyze: "Analizza",
  no_recording_data_available: "Nessun dato di sessione disponibile.",
  recording_session: "Sessione di lavoro",
  local_recording_unavailable:
    "La mappatura del lavoro è disponibile solo nell'app desktop di Platonic.",
  activity_feed: "Feed attività",
  live_activity_captured_during_recording: "Attività live catturata durante la sessione.",
  no_feed_events_yet: "Nessuna attività nel feed al momento.",
  back_to_previous_page: "Torna alla pagina precedente",
  request_failed: "Richiesta fallita",
  invalid_request: "La richiesta non e' valida.",
  invalid_form: "Alcuni campi del modulo non sono validi.",
  invalid_form_with_fields: "Alcuni campi del modulo non sono validi: {{fields}}.",
  invalid_form_field: "{{field}} {{errors}}",
  form_field_missing: "Il campo e' obbligatorio",
  form_field_invalid_type: "ha il tipo sbagliato",
  form_field_invalid_value: "ha un valore non valido",
  form_field_invalid_foreign_key: "Seleziona un'opzione valida",
  form_field_invalid_email: "Inserisci un indirizzo email valido",
  form_field_value_too_long: "Deve contenere al massimo {{max}} caratteri",
  form_field_value_too_big: "Deve essere al massimo {{max}}",
  form_field_value_too_short: "Deve contenere almeno {{min}} caratteri",
  form_field_value_too_small: "Deve essere almeno {{min}}",
  form_field_password_missing_lowercase: "Includi una lettera minuscola",
  form_field_password_missing_uppercase: "Includi una lettera maiuscola",
  form_field_password_missing_digit: "Includi un numero",
  form_field_password_missing_symbol: "Includi un simbolo, per esempio !, @, # o .",
  form_field_password_too_weak: "Scegli una password piu' robusta",
  invalid_json: "Il corpo della richiesta non e' JSON valido.",
  invalid_websocket_upgrade: "La richiesta di upgrade websocket non e' valida.",
  invalid_password: "La password non rispetta i requisiti di sicurezza.",
  invalid_path_parameter: "Il parametro URL {{parameter}} non e' valido.",
  invalid_query_parameter: "Il parametro query {{parameter}} non e' valido.",
  unsupported_value: "Il valore per {{field}} non e' supportato.",
  permission_denied_reason: {
    generic: "Non hai i permessi per eseguire questa azione.",
    missing_recording_permission: "Platonic richiede il permesso {{permission}} per registrare.",
    admin_required: "Solo gli amministratori possono eseguire questa azione.",
    manage_users_required: "Non hai i permessi per gestire gli utenti.",
    create_users_required: "Non hai i permessi per creare utenti.",
    manage_vocabulary_required: "Non hai i permessi per gestire il vocabolario aziendale.",
    manage_prompts_required: "Non hai i permessi per configurare i prompt.",
    own_recording_required: "Puoi modificare solo le tue registrazioni.",
    recording_delete_forbidden: "Non puoi eliminare questa registrazione.",
    recording_owner_access_forbidden:
      "Non puoi accedere alle registrazioni di questo utente con i tuoi permessi.",
    analysis_diagnostics_forbidden: "Non hai i permessi per vedere la diagnostica dell'analisi.",
    analysis_runs_forbidden:
      "Non hai i permessi per lavorare sulle analisi di questa registrazione.",
    reanalyze_recording_forbidden:
      "Non hai i permessi per rianalizzare una registrazione gia' analizzata.",
    recording_screenshot_forbidden: "Non puoi accedere agli screenshot di questa registrazione.",
    sync_model_id_forbidden: "Non puoi creare un {{model}} con questo id.",
    sync_model_read_only: "I modelli sync di azienda e utente sono in sola lettura.",
    release_proxy_repo_forbidden:
      "Non puoi accedere a un repository diverso da platonic-research/clank-core.",
  },
  too_many_requests: "Troppe richieste. {{details}}",
  conflict: "La richiesta e' in conflitto con lo stato corrente.",
  analysis_already_running:
    "Questa registrazione e' gia' in fase di analisi. Attendi che l'analisi in corso finisca, o interrompila, prima di avviarne un'altra.",
  service_temporarily_unavailable: "Il servizio e' temporaneamente non disponibile.",
  answer_too_long:
    "La risposta era troppo lunga per essere consegnata. Prova a fare una domanda più circoscritta.",
  unexpected_error: "Si e' verificato un errore inatteso.",
  resource_not_found: "{{resource}} non trovato{{lookup}}.",
  resource_conflict: "{{resource}} esiste gia'{{lookup}}.",
  api_error_lookup_by_field: " per {{field}} {{value}}",
  api_error_lookup_by_fields: " per {{fields}}",
  api_error_lookup_unspecified: "",
  resource_kind_user: "Utente",
  resource_kind_company: "Azienda",
  resource_kind_alert: "Avviso",
  resource_kind_recording: "Sessione",
  resource_kind_recording_command: "Comando sessione",
  resource_kind_recording_event_log: "Log eventi sessione",
  resource_kind_recording_os_permission: "Permesso registrazione",
  resource_kind_process: "Processo",
  resource_kind_process_instance: "Caso",
  resource_kind_workflow: "Workflow",
  resource_kind_workflow_version: "Versione workflow",
  resource_kind_ran_workflow: "Esecuzione workflow",
  resource_kind_oidc_provider: "Provider OIDC",
  resource_kind_sync_model: "Modello sync",
  resource_kind_vocabulary_entry: "Voce del vocabolario",
  resource_kind_prompt_snippet: "Snippet di prompt",
  resource_kind_prompt_slot: "Sezione di prompt",
  resource_kind_object: "Oggetto",
  resource_kind_classification_category: "Categoria",
  back: "Indietro",
  failed_to_load_process: "Impossibile caricare il processo",
  process_detail: "Dettaglio processo",
  observed: "osservato",
  total_duration: "Durata totale",
  steps_per_instance_full: "Passaggi medi per caso",
  also_seen_as: "Visto anche come",
  chat: "Chat",
  ask: "Chiedi",
  step_details: "Dettagli del passaggio",
  transition_details: "Dettagli della transizione",
  node_hover_hint: "Passaggio del processo: clicca per i dettagli",
  process_graph_label: "Grafo del processo",
  browse_all_processes: "Sfoglia tutti i processi",
  sort_processes: "Ordina processi",
  feedback: {
    title: "Condividi un feedback",
    description:
      "Il tuo feedback arriva direttamente al team di Platonic. Il contesto di questa pagina viene incluso automaticamente.",
    message_label: "Il tuo feedback",
    message_placeholder:
      "Cosa stavi cercando di fare?\nCosa ti è sembrato poco chiaro, lento o inatteso?\nCosa l'avrebbe reso migliore?",
    take_screenshot: "Cattura schermata",
    taking_screenshot: "Cattura in corso...",
    attach_image: "Allega immagine",
    drop_image: "Rilascia l'immagine per allegarla",
    remove_screenshot: "Rimuovi screenshot",
    screenshot_alt: "Screenshot allegato",
    submit: "Invia feedback",
    sent_title: "Grazie per il tuo feedback",
    sent_description: "Il tuo feedback è stato inviato al team di Platonic.",
  },
  process_directory: {
    favourites_hint: "Solo i processi aggiunti ai preferiti.",
    feedback_title: "Manca un processo o hai notato qualcosa di sbagliato?",
    feedback_hint: "Il tuo feedback aiuta a rendere Platonic più preciso.",
    feedback_action: "Condividi un feedback",

    subtitle_team: "Esplora il lavoro del tuo team. Apri un processo per vedere come si svolge.",
    subtitle_personal: "Esplora il tuo lavoro. Apri un processo per vedere come si svolge.",
    group_frequency: "Frequenza",
    bucket_favourites: "Preferiti",
    bucket_not_favourites: "Altri processi",
    group_intensity: "Intensità temporale",
    bucket_frequent: "Frequenti ({{minimum}}+)",
    bucket_occasional: "Occasionali (fino a {{maximum}})",
    bucket_long: "Più impegnativi in termini di tempo",
    bucket_short: "Meno impegnativi in termini di tempo",
    long_hint: "Durata media per caso di almeno un’ora.",
    short_hint: "Durata media per caso inferiore a un’ora.",
    group_by: "Raggruppa per",
    group_none: "Nessuno",
    group_domain: "Area aziendale",
    group_pattern: "Schema di processo",
    bucket_unclassified: "Non classificati",
    unclassified_hint: "Analizzati prima che i processi venissero classificati.",
    unknown_category: "Categoria sconosciuta",
    group_person: "Persona",
    group_application: "Applicazione",
    unknown_application: "Applicazione non disponibile",
    time_unavailable: "Tempo non disponibile",
    time_in_app: "Tempo nell’app",
    time_in_app_hint:
      "Tempo trascorso in questa app durante il processo e la sua quota sul tempo totale del processo.",
    share_of_team: "Quota del team",
    share_of_team_hint: "Quota di questa persona sul tempo totale del team per il processo.",
    share_of_team_detail: "{{duration}} su {{total}} del team",
    time_in_app_detail: "{{duration}} in {{app}}, su {{total}} totali",
    group_app_duration: "{{duration}} in {{app}}",
    from_grouping: "Dal raggruppamento",
    hidden_by_person_grouping: "Nascosta con raggruppamento per persona",
    clear_filters: "Cancella filtri",
    sort_within_groups: "Ordina nei gruppi",
    sort_by: "Ordina per",
    sort_recent: "Osservati più di recente",
    sort_shared: "Più condivisi",
    process: "Processo",
    people: "Persone",
    tools: "App",
    case_count: "Numero di casi",
    instances: "Casi",
    avg_duration: "Durata media",
    total_time: "Tempo totale",
    last_observed: "Ultima osservazione",
    placeholder_description: "Descrizione del processo in arrivo.",
    placeholder_hint: "Descrizione provvisoria",
    unknown_person: "Persona sconosciuta",
    unavailable: "Non disponibile",
    open_process: "Apri {{name}}",
    open: "Apri processo",
    group_count_one: "{{count}} processo",
    group_count_other: "{{count}} processi",
    group_total_duration: "{{duration}} in totale",
    directory_count: "{{groups}} gruppi di processi · {{count}} processi",
    show_more: "Mostra altri {{count}}",
    show_less: "Mostra meno",
    total_time_hint:
      "Tempo osservato cumulativo dei casi; le attività simultanee possono sovrapporsi.",
    median_duration: "Durata mediana",
    avg_steps: "Passaggi medi",
    display: "Visualizzazione",
    columns: "Colonne",
    reset_display: "Ripristina predefinite",
    display_customized: "Personalizzata",
  },
  process_sort_frequency: "Più frequenti",
  process_sort_name: "Nome (A–Z)",
  process_sort_duration: "Durata media più lunga",
  switch_process: "Cambia processo",
  zoom_in: "Ingrandisci",
  zoom_out: "Riduci",
  search_steps: "Cerca passaggi",
  previous_search_match: "Risultato precedente",
  next_search_match: "Risultato successivo",
  no_search_matches: "0/0",
  close_search: "Chiudi ricerca",
  set_zoom_percentage: "Imposta la percentuale di zoom",
  view_controls: "Controlli di vista",
  app: "App",
  times: "Volte",
  process_instance_n: "Caso {{num}}",
  scope_instance_count: "{{selected}} di {{total}} casi",
  process_more_actions: "Altre azioni",
  process_watch: "Monitora",
  show_process_details: "Mostra dettagli del processo",
  hide_process_details: "Nascondi dettagli del processo",
  compare_runs: "Confronta casi",
  compare_run_a: "Caso A",
  compare_run_b: "Caso B",
  compare_choose_run: "Scegli un caso…",
  compare_runs_help: "Scegli due casi dalla selezione attuale.",
  compare: "Confronta",
  exit_compare: "Esci dal confronto",
  watch_this_process: "Monitora questo processo",
  comparing: "Confronto",
  compare_with: "Confronta con",
  switch_instance: "Cambia caso",
  instances_in_scope: "Casi nell'ambito",
  compare_pick_side: "Confronta con",
  compare_swap_sides: "Inverti i lati",
  compare_metric: "Metrica",
  compare_delta: "Δ",
  compare_total_duration: "Durata",
  compare_total_duration_help: "Durata spiegata",
  compare_total_duration_help_text:
    "Solo il tempo attivo trascorso sui passi. Le attese tra un passo e l'altro non sono conteggiate.",
  compare_waiting_time: "Attese tra i passi",
  compare_waiting_time_help: "Attese tra i passi spiegate",
  compare_waiting_time_help_text:
    "La somma delle pause rilevate tra la fine di un passo e l'inizio del successivo.",
  compare_steps: "Passi",
  compare_rework: "Passi ripetuti",
  compare_step_flow: "Passo per passo",
  compare_shared_steps: "{{count}} passaggi in comune",
  compare_shared_steps_one: "{{count}} passaggio in comune",
  compare_focus_step: "Mostra {{step}}",
  compare_step_skipped: "Non eseguito in questo caso",
  compare_show_step_detail: "Mostra cosa ha fatto {{label}} qui",
  compare_hide_step_detail: "Nascondi cosa ha fatto {{label}} qui",
  graph_settings: "Impostazioni grafico",
  advanced: "Avanzate",
  color: "Colore",
  color_by: "Colora per",
  color_none: "Nessuno",
  color_time: "Durata",
  step_reading: "Mostra sui passaggi",
  step_reading_help:
    "Automatico mostra i casi quando il traffico è attivo, e altrimenti le occorrenze con la durata media.",
  step_reading_auto: "Automatico",
  step_reading_visits_avg: "Occorrenze · durata media",
  step_reading_total_time: "Durata totale",
  step_reading_cases: "Casi",
  step_reading_none: "Niente",
  edge_routing: "Connessioni",
  edge_routing_bundled: "Raggruppate",
  edge_routing_separate: "Separate",
  edge_routing_help:
    "Raggruppate unisce le frecce che condividono un passaggio in un unico tronco che si divide dove i flussi divergono.",
  traffic: "Traffico",
  traffic_help:
    "Disegna ogni connessione più spessa quanto più spesso i casi la percorrono, e segnala le attese più lunghe. Disattivo di default.",
  traffic_off: "Disattivo",
  traffic_on: "Attivo",
  reset_view: "Reimposta vista",
  fit_to_screen: "Adatta allo schermo",
  time_share: "Quota di tempo",
  time_share_matching_instances_help: "Informazioni sulla quota di tempo",
  time_share_matching_instances_tooltip:
    "Frazione di tempo trascorsa in questo passaggio nei casi in cui è presente.",
  decision_step: "Passaggio decisionale",
  app_usage: "Utilizzo app",
  step_next_steps: "Passaggi successivi",
  transition: "Transizione",
  transitions: "Transizioni",
  focus_transition: "Evidenzia la transizione da {{from}} a {{to}}",
  edge_departures_label: "Uscite",
  edge_departures_help: "Informazioni sulle uscite",
  edge_departures_tooltip:
    "Percentuale di uscite dal passaggio di origine che hanno seguito questa transizione.",
  edge_average_wait_label: "Attesa media",
  edge_average_wait_help: "Informazioni sull'attesa media",
  edge_average_wait_tooltip:
    "Tempo medio tra la fine del passaggio di origine e l'inizio del passaggio successivo.",
  branches: "Diramazioni",
  n_cases: "{{count}} casi",
  n_cases_one: "{{count}} caso",
  ask_why: "Chiedi perché",
  ask_why_time_sink: "Chiedi perché {{step}} richiede così tanto tempo",
  ask_why_waiting_time: "Chiedi perché c'è un'attesa da {{from}} a {{to}}",
  ask_why_transition: "Chiedi perché {{from}} passa a {{to}}",
  ask_why_duration_variability: "Chiedi perché le durate del processo variano così tanto",
  ask_branching_prompt:
    "Perché “{{name}}” si dirama in questi diversi passaggi successivi e quali fattori determinano il percorso seguito?",
  ask_transition_prompt: "Perché “{{from}}” passa a “{{to}}” nel {{percentage}}% dei casi?",
  ask_time_sink_prompt:
    "Perché “{{name}}” rappresenta il {{percentage}}% del tempo del processo e come viene impiegato il tempo all'interno di questo passaggio?",
  ask_waiting_time_prompt:
    "Questa transizione si è verificata {{count}} volte e ha un tempo di attesa medio rilevato di {{duration}}. Le attese tra “{{from}}” e “{{to}}” erano dovute ad attività non correlate oppure ad attività preliminari necessarie per iniziare il passaggio successivo? Confronta le attese più lunghe con i casi tipici e identifica le condizioni che le generano.",
  ask_waiting_time_single_prompt:
    "Questa transizione si è verificata una volta, con un tempo di attesa rilevato di {{duration}}. L'attesa di {{duration}} tra “{{from}}” e “{{to}}” era dovuta ad attività non correlate oppure ad attività preliminari necessarie per iniziare il passaggio successivo?",
  ask_duration_variability_prompt:
    "Perché i casi di “{{name}}” variano così tanto nella durata? Confronta i casi più lunghi con quelli tipici, individua i passaggi o le condizioni che determinano la differenza e spiega dove viene impiegato il tempo aggiuntivo.",
  ask_about_instance: "Chiedi su questo caso",
  ask_why_compare_metric: "Chiedi perché {{metric}} è diverso tra {{a}} e {{b}}",
  ask_compare_count_metric_prompt:
    "Sto confrontando due casi di “{{process}}”: {{a}} e {{b}}. Su {{metric}}, {{a}} riporta {{aValue}} e {{b}} riporta {{bValue}} ({{delta}} per {{b}}). A cosa è dovuta questa differenza — quali condizioni nei due casi la spiegano?",
  ask_compare_metric_prompt:
    "Sto confrontando due casi di “{{process}}”: {{a}} e {{b}}. Su {{metric}}, {{a}} riporta {{aValue}} e {{b}} riporta {{bValue}} ({{delta}} per {{b}}). A cosa è dovuta questa differenza — quali passaggi o condizioni nei due casi la spiegano?",
  ask_about: "Chiedi info",
  ask_instance_prompt:
    "Guidami passo dopo passo attraverso ciò che è successo in “{{name}}” e segnala tutto ciò che è insolito o che merita un approfondimento.",
  duration_analytics: "Analisi della durata",
  duration_distribution: "Istogramma durata",
  median: "Mediana",
  trend_over_time: "Andamento nel tempo",
  start: "Inizio",
  end: "Fine",
  duration: "Durata",
  duration_avg: "Durata (media)",
  traces_begin_here: "tracce iniziano qui",
  traces_end_here: "tracce finiscono qui",
  occurrences: "Occorrenze",
  step_occurrence: "Occorrenza del passo",
  occurrence_position: "{{current}}/{{total}}",
  occurrence_position_accessible: "Occorrenza {{current}} di {{total}}",
  previous_occurrence: "Occorrenza precedente",
  next_occurrence: "Occorrenza successiva",
  step_position_long: "Passaggio {{current}} di {{total}}",
  step_position_compact: "Passaggio {{current}}/{{total}}",
  step_position_start: "Inizio",
  step_position_end: "Fine",
  instance_view: "Dettagli caso",
  open_occurrence_instance_hint: "Apri il caso a questa occorrenza ({{label}})",
  instances_through_step_title: "Casi che includono questo passaggio",
  instances_through_transition_title: "Casi che includono questa transizione",
  open_instance_view_hint: "Apri i dettagli del caso {{label}}",
  view_instance_action: "Apri",
  back_to_overview: "Torna alla panoramica del processo",
  back_to_step_details: "Torna ai dettagli del passaggio",
  back_to_transition_details: "Torna ai dettagli della transizione",
  instance_steps_chronological: "Passaggi del caso in ordine cronologico",
  instance_step_keys_hint: "Scorri i passaggi",
  instance_step_keys_hint_sides: "Cambia caso",
  instance_step_keys_hint_enter: "Vedi i dettagli",
  instance_wait_gap: "{{duration}} di attesa",
  instance_wait_gap_between: "Attesa di {{duration}} tra “{{from}}” e “{{to}}”",
  ask_why_waiting_time_gap: "Chiedi perché c'è un'attesa di {{duration}} da {{from}} a {{to}}",
  open_instance_recording: "Apri la sessione di {{instance}}",
  objects: "Oggetti",
  screenshots: "Screenshot",
  no_description: "Nessuna descrizione per questa occorrenza.",
  no_objects: "Nessun oggetto per questa occorrenza.",
  expand_section: "Espandi {{section}}",
  collapse_section: "Comprimi {{section}}",
  show_more: "Mostra altro",
  show_less: "Mostra meno",
  time_allocation: "Allocazione del tempo",
  by_process: "per processo",
  by_app: "per app",
  other_apps: "Altre app",
  idle: "Lontano dalla tastiera / mappatura in pausa",
  process_breakdown: "Dettaglio processi",
  filter_by_app: "Filtra per app",
  all_apps: "Tutte le app",
  add_app: "Aggiungi app",
  remove_app_filter: "Rimuovi filtro {{app}}",
  showing_n_of_m_processes: "{{shown}} di {{count}} processi",
  showing_n_of_m_processes_one: "{{shown}} di {{count}} processo",
  instances_of_total: "{{shown}} di {{count}} casi",
  instances_of_total_one: "{{shown}} di {{count}} caso",
  n_instances: "{{count}} casi",
  n_instances_one: "{{count}} caso",
  n_processes: "{{count}} processi",
  n_processes_one: "{{count}} processo",
  percent_in_app: "{{pct}}% in {{app}}",
  no_instances_use_app: "Nessun caso usa {{app}}.",
  no_meaningful_process_was_found: "Nessun processo rilevante trovato.",
  irrelevant_processes: "Attività non strutturata",
  session_timeline: "Timeline sessione",
  events_per_process_trace: "Passaggi per traccia di processo",
  process_trace: "Traccia di processo",
  events: "Passaggi",
  avg_length: "Durata media",
  discovered_processes: "Processi scoperti",
  processes_across_your_recordings: "{{count}} processi nelle sessioni analizzate",
  processes_across_your_recordings_one: "{{count}} processo nelle sessioni analizzate",
  failed_to_load_processes: "Impossibile caricare i processi",
  add_process_to_favourites: "Aggiungi {{name}} ai preferiti",
  remove_process_from_favourites: "Rimuovi {{name}} dai preferiti",
  add_to_favourites: "Aggiungi ai preferiti",
  remove_from_favourites: "Rimuovi dai preferiti",
  favourites: "Preferiti",
  no_processes_discovered_yet_record_some_sessions_first:
    "Nessun processo scoperto al momento. Mappa prima un po' di lavoro.",
  recorded: "mappati",
  useless: "inutili",
  update_required: "Aggiornamento richiesto",
  platonic_is_ready_to_install: "Platonic {{version}} è pronto per l'installazione",
  the_update_has_already_been_downloaded_installation_must_be_completed_before_continuing:
    "L'aggiornamento è già stato scaricato. L'installazione deve essere completata prima di continuare.",
  release_notes: "Note di rilascio",
  install_update_now: "Installa aggiornamento ora",
  stop_recording_and_install_update: "Interrompi la mappatura e installa l'aggiornamento",
  page_not_found: "Pagina non trovata",
  no_results_for: "Nessun risultato per",
  connection_to_ws_lost: "Connessione al WS persa",
  already_trying_to_reconnect_please_wait: "Sto già provando a riconnettermi, attendi.",
  app_loading_redirect_soon:
    "L'applicazione è ancora in caricamento, verrai reindirizzato a breve...",
  arguments: "Argomenti",
  details: "Dettagli",
  description: "Descrizione",
  executive_dashboard_description: "Strumenti per gestire utenti e sessioni.",
  user_management: "Gestione utenti",
  manage_users_description: "Consulta gli utenti e crea nuovi account.",
  user_management_description:
    "Controlla gli utenti dell'azienda e crea un nuovo utente con i permessi predefiniti.",
  users: "Utenti",
  companies: "Aziende",
  loading_users: "Caricamento utenti...",
  company: "Azienda",
  loading_companies: "Caricamento aziende...",
  companies_count: "{{count}} aziende",
  companies_count_one: "{{count}} azienda",
  users_count: "{{count}} utenti",
  users_count_one: "{{count}} utente",
  create_company: "Crea azienda",
  create_company_description: "Crea un'azienda a cui assegnare gli utenti.",
  creating_company: "Creazione azienda...",
  company_created: "Azienda creata.",
  company_id: "ID azienda",
  company_name: "Nome azienda",
  company_logo_url: "URL logo",
  allow_password_login: "Consenti login con password",
  allow_password_login_description:
    "Gli utenti di questa azienda possono accedere con nome utente e password.",
  create_user: "Crea utente",
  create_user_description: "Crea un nuovo utente aziendale.",
  creating_user: "Creazione utente...",
  enroll_user: "Iscrivi utente",
  enroll_user_description: "Crea un utente e inviagli un'email di iscrizione.",
  enrolling_user: "Iscrizione utente...",
  user_enrollment_sent: "Email di iscrizione inviata.",
  send_enrollment_email: "Invia email di iscrizione",
  send_enrollment_email_to_user: "Invia email di iscrizione a {{username}}",
  send_enrollment_email_confirmation: "L'email di iscrizione verra inviata a {{email}}.",
  enrollment_resets_password_warning: "Questa azione reimpostera la password dell'utente.",
  enrollment_onboarding_email_warning:
    "Questa azione inviera la stessa email di onboarding usata per un nuovo utente.",
  enrollment_existing_missing_email:
    "Questo utente non ha un indirizzo email, quindi non e possibile inviare l'email di iscrizione.",
  impersonate_user: "Impersona utente",
  impersonate_user_help:
    "Crea una sessione del browser come un altro utente. Questo sostituisce la sessione corrente in questo browser.",
  select_user_to_impersonate: "Seleziona utente da impersonare",
  start_impersonation: "Avvia impersonazione",
  username: "Nome utente",
  password: "Password",
  email: "Email",
  first_name: "Nome",
  last_name: "Cognome",
  name: "Nome",
  actions: "Azioni",
  edit_company: "Modifica azienda",
  save_company: "Salva azienda",
  password_login_enabled: "Attivo",
  password_login_disabled: "Disattivo",
  edit_user: "Modifica utente",
  save_user: "Salva utente",
  manage_user_permissions: "Gestisci permessi",
  user_permissions: "Permessi utente",
  user_permissions_description: "Controlla e aggiorna le regole di accesso dell'utente.",
  save_user_permissions: "Salva permessi",
  permissions_updated: "Permessi aggiornati.",
  back_to_user_management: "Torna alla gestione utenti",
  failed_to_load_user_permissions: "Impossibile caricare i permessi utente",
  failed_to_update_user_permissions: "Impossibile aggiornare i permessi utente",
  selected_user_not_found: "Utente selezionato non trovato",
  simplified_permission_form: "Modulo permessi semplificato",
  admin_user: "Utente admin",
  recordings_permissions: "Permessi sessioni",
  processes_permissions: "Permessi processi",
  screenshots_permissions: "Permessi screenshot",
  users_permissions: "Permessi utenti",
  can_create_users: "Può creare utenti",
  permission_scope: "Ambito",
  permission_only_mine: "Solo propri",
  permission_all_company: "Tutta l'azienda",
  permission_specific_users: "Utenti specifici",
  permission_all: "Tutti gli utenti",
  specific_users: "Utenti specifici",
  new_password_optional: "Nuova password (opzionale)",
  confirm_password: "Conferma password",
  back_to_executive_dashboard: "Torna all’amministrazione",
  failed_to_load_users: "Impossibile caricare gli utenti",
  failed_to_load_companies: "Impossibile caricare le aziende",
  failed_to_create_user: "Impossibile creare l'utente",
  failed_to_enroll_user: "Impossibile iscrivere l'utente",
  failed_to_update_user: "Impossibile aggiornare l'utente",
  failed_to_update_company: "Impossibile aggiornare l'azienda",
  passwords_do_not_match: "Le password non corrispondono.",
  you_do_not_have_permission_to_create_users: "Non hai i permessi per creare nuovi utenti.",
  you_do_not_have_permission_to_create_companies: "Non hai i permessi per creare aziende.",
  you_do_not_have_permission_to_edit_companies: "Non hai i permessi per modificare aziende.",
  you_do_not_have_permission_to_edit_users: "Non hai i permessi per modificare gli utenti.",
  show_n_screenshots: "Mostra {{count}} screenshot",
  failed_to_load_screenshot: "Errore nel caricamento dello screenshot",
  screenshot_n_of_total: "Screenshot {{current}} di {{total}}",
  previous_screenshot: "Screenshot precedente",
  next_screenshot: "Screenshot successivo",
  play_screenshot_autoplay: "Riproduci screenshot",
  pause_screenshot_autoplay: "Metti in pausa gli screenshot",
  screenshot_playback_speed: "Velocità di riproduzione",
  start_at_stage: "Inizia dalla fase",
  use_lift_tools: "Usa gli strumenti LLM",
  filters: "Filtri",
  search_people: "Cerca persone…",
  people_you: "{{name}} (Tu)",
  people_only_you: "Solo tu",
  search_in_processes: "Cerca nei processi…",
  search_recordings: "Cerca per nome…",
  from: "Da",
  to: "A",
  min: "Min",
  max: "Max",
  step_count: "Numero di passaggi",
  repetitions: "Ripetizioni",
  clear_all_filters: "Cancella tutti i filtri",
  no_results_match_filters: "Nessun risultato corrisponde ai filtri.",
  showing_n_of_total: "{{filtered}} di {{total}} mostrati",
  chat_back_to_details: "Torna ai dettagli",
  chat_close_sidebar: "Chiudi pannello laterale",
  chat_across_sessions: "Chiedi su più sessioni",
  sessions_scope: "Ambito delle sessioni",
  my_sessions: "Le mie sessioni",
  team_sessions: "Sessioni del team",
  sessions_navigator: "Navigazione delle sessioni",
  sessions_latest: "Ultima sessione",
  sessions_view: "Vista sessioni",
  sessions_empty_scope: "Nessuna sessione in questa vista. Prova Attive, Archiviate o Tutte.",
  sessions_timeline_group: "{{count}} sessioni",
  sessions_timeline_reset: "Mostra 7 giorni attorno alla sessione selezionata",
  sessions_timeline_days: "{{count}} giorni",
  sessions_timeline_days_one: "{{count}} giorno",
  sessions_timeline_help: "Scorri per esplorare · Ctrl + scorri per lo zoom",
  sessions_empty_personal: "Le tue sessioni appariranno qui dopo aver mappato il tuo lavoro.",
  sessions_previous: "Sessione precedente",
  sessions_next: "Sessione successiva",
  sessions_session: "Sessione",
  sessions_date_time: "Data e ora",
  sessions_analysis: "Analisi",
  sessions_analysis_ready: "Pronta",
  sessions_not_analyzed: "Non analizzata",
  chat_this_session: "Questa sessione",
  chat_alert_paused: "Avviso in pausa",
  chat_pause_alert: "Metti in pausa",
  chat_resume_alert: "Riattiva avviso",
  chat_manage_alert: "Modifica avviso",
  chat_alert_update_failed: "Impossibile aggiornare l’avviso. Riprova.",
  chat_history_empty: "Nessuna conversazione.",
  chat_recent: "Cronologia",
  chat_expand: "Espandi conversazione",
  chat_collapse: "Torna alla barra laterale",
  chat_following_page: "Segue la pagina",
  chat_custom_context: "Contesto personalizzato",
  chat_use_session: "Usa questa sessione",
  chat_use_runs: "Usa questi casi",
  chat_selected_runs: "{{count}} casi selezionati",
  chat_change_selection: "Cambia selezione",
  chat_session_processes: "Tutti i processi in questa sessione",
  chat_panel_modes: "Pannello processo",
  chat_details: "Dettagli",
  chat_ask_result: "Fai una domanda di approfondimento",
  chat_ask_result_hint:
    "Approfondisci questo risultato in Ask, con il report allegato come contesto.",
  chat_alert_result: "Risultato avviso",
  chat_result_data:
    "Risultato salvato. I filtri sotto selezionano i dati per le domande successive.",
  chat_result_scope_unknown:
    "Selezione originale non disponibile: i filtri usano le impostazioni attuali dell’avviso alla data del risultato.",
  chat_alert_example_duration: "Avvisami quando aumenta la durata media dei casi.",
  chat_alert_example_manual: "Riepiloga il tempo dedicato all’inserimento manuale dei dati.",
  chat_alert_example_rework: "Evidenzia i passaggi che vengono ripetuti più spesso.",
  chat_follow_page: "Usa la selezione della pagina",
  chat_change_context: "Modifica",
  chat_custom_context_help:
    "Oppure scegli persone, processi e un periodo mobile per le prossime domande. Sostituisce la selezione della pagina.",
  chat_apply_context: "Usa questo contesto",
  chat_kpi_scope_help:
    "Scegli cosa monitorare e rispondi alle eventuali domande. Il KPI verrà creato automaticamente e potrai modificarlo in Insight.",
  chat_kpi_process_help:
    "L’avviso controlla tutti i casi del processo selezionato. I filtri su singoli passaggi e casi non vengono mantenuti.",
  chat_kpi_session_help:
    "L’avviso controlla le nuove sessioni. Scegli le persone e il periodo da monitorare.",
  chat_kpi_creating: "Creazione KPI…",
  chat_kpi_retry: "Riprova a creare il KPI",
  chat_kpi_review_failed: "Impossibile preparare il KPI. Riprova.",
  chat_kpi_saved: "KPI creato",
  chat_kpi_saved_help: "Puoi modificare questo KPI in qualsiasi momento in Insight.",
  chat_kpi_view: "Visualizza KPI",
  chat_back_to_conversation: "Conversazione",
  chat_track_this: "Monitora come KPI",
  chat_track_this_hint: "Ripeti questa domanda periodicamente e segui come cambia la risposta.",
  chat_track_this_dismiss: "Nascondi il suggerimento KPI",
  chat_opens_sidebar: "Apre Ask nella barra laterale",
  chat_new_question: "Nuova conversazione",
  chat_scope_label: "Chiedi informazioni su",
  chat_scope_changed: "Ambito cambiato in: {{label}}",
  chat_selected_steps: "Passaggi selezionati",
  chat_remove_selected_step: "Rimuovi {{step}} dal contesto della chat",
  chat_ask_tooltip:
    "Questi filtri si applicano alla prossima domanda. La conversazione mantiene il contesto quando cambi pagina.",
  chat_ephemeral_warning: "Questa chat è temporanea e verrà persa al riavvio dell'app.",
  chat_getting_long:
    "Questa conversazione si sta allungando. Iniziane una nuova per risposte più rapide.",
  chat_too_long:
    "Questa conversazione è troppo lunga per continuare. Iniziane una nuova per fare altre domande.",
  chat_too_many_messages:
    "Questa conversazione ha raggiunto il limite di messaggi. Iniziane una nuova per fare altre domande.",
  chat_input_mentions_placeholder: "Chiedi su questi dati… Digita @ per il contesto",
  chat_input_placeholder: "Fai una domanda su questi dati…",
  chat_ai_disclaimer:
    "Le risposte sono generate da un'IA e possono contenere errori. Verifica le informazioni importanti.",
  chat_send: "Invia",
  chat_stop: "Ferma",
  chat_copy: "Copia",
  chat_copied: "Copiato",
  chat_quote_in_reply: "Cita nella risposta",
  chat_error_generic: "L'assistente non è riuscito a rispondere. Riprova.",
  chat_static_demo_unavailable:
    "Questa funzionalità è disponibile solo nella versione reale di Platonic.",
  chat_dismiss_error: "Chiudi",
  chat_thinking_analyzing_process_context: "Analisi del contesto del processo...",
  chat_thinking_listing_recordings: "Elenco delle sessioni...",
  chat_thinking_reading_recording_metadata: "Lettura dei metadati della sessione...",
  chat_thinking_reading_process_instances: "Lettura dei casi...",
  chat_thinking_inspecting_analysis_details: "Ispezione dei dettagli dell'analisi...",
  chat_thinking_searching_in_nodes: "Ricerca nei nodi dell'analisi...",
  chat_thinking_computing_node_metrics: "Calcolo delle metriche...",
  chat_thinking_analyzing_screenshots: "Analisi degli screenshot...",
  chat_thinking_running_subagents: "Esecuzione dei subagent...",
  chat_thinking_reasoning: "Sto ragionando...",
  chat_thinking_preparing_final_answer:
    "Preparazione della risposta con le informazioni già raccolte...",
  chat_suggestion_time_sink: "Qual è il passaggio che richiede più tempo?",
  chat_suggestion_differences: "Dove differiscono di più i casi?",
  chat_suggestion_summary: "Riassumi questo processo per un nuovo membro del team.",
  chat_with_recording: "Chatta con la sessione",
  chat_new_conversation: "Svuota la chat e iniziane una nuova",
  chat_suggestion_recording_time: "Dove è andato il tempo in questa sessione?",
  chat_suggestion_recording_summary: "Riassumi cosa è stato fatto in questa sessione.",
  chat_suggestion_recording_unstructured: "Cosa è successo al di fuori dei processi principali?",
  vocabulary: "Vocabolario",
  vocabulary_page_description:
    "I nomi di processi e passaggi che l'analisi preferisce nell'etichettare le sessioni. I contributi guidano solo le analisi future.",
  add_to_vocabulary: "Standardizza i nomi",
  vocabulary_scope_label: "Si applica a",
  vocabulary_scope_user: "Solo le mie analisi",
  vocabulary_scope_company: "Tutta l'azienda",
  change_vocabulary: "Modifica i nomi standard",
  vocabulary_updating_entry: "Salvataggio…",
  vocabulary_names_saved: "Nomi salvati",
  vocabulary_blank_name: "Un nome non può essere vuoto. Compilalo o lascialo fuori.",
  vocabulary_no_names: "Seleziona almeno un nome di passaggio prima di salvare.",
  vocabulary_popover_title: "Imposta questi come nomi standard per le sessioni future",
  vocabulary_popover_lede:
    "La prossima volta che questo lavoro comparirà, l'analisi lo etichetterà con i nomi selezionati qui sotto invece di inventarne di nuovi. Le analisi passate non ne sono influenzate.",
  vocabulary_popover_help: "Come funziona",
  vocabulary_popover_process_label: "Nome di questo processo",
  vocabulary_popover_steps_label: "Nomi dei suoi passaggi",
  vocabulary_saved_steps_label: "Nomi già salvati",
  vocabulary_new_steps_label: "Nuovi nomi in questa analisi",
  vocabulary_select_all: "Seleziona tutti",
  vocabulary_select_none: "Deseleziona tutti",
  vocabulary_save_names: "Salva questi nomi",
  vocabulary_override_hint:
    "Per questo processo esiste già una definizione. Salvando la sostituisci.",
  vocabulary_scope_badge_builtin: "integrata",
  vocabulary_scope_badge_personal: "personale",
  vocabulary_overridden_definitions: "{{count}} definizioni sostituite",
  vocabulary_overridden_definitions_one: "{{count}} definizione sostituita",
  vocabulary_create_override: "Sostituisci",
  vocabulary_edit_entry: "Modifica",
  vocabulary_new_entry: "Nuova voce",
  vocabulary_process_name: "Nome del processo",
  vocabulary_steps_hint: "Passaggi (uno per riga)",
  vocabulary_add_entry: "Aggiungi voce",
  vocabulary_adding_entry: "Aggiunta in corso…",
  vocabulary_delete_entry: "Elimina",
  vocabulary_empty: "Ancora nessuna voce nel vocabolario.",
  vocabulary_contributed_by_you: "tu",
  vocabulary_scope_badge_company: "aziendale",
  failed_to_load_vocabulary: "Impossibile caricare il vocabolario",
  vocabulary_categories: "Categorie",
  vocabulary_processes: "Processi",
  n_categories: "{{count}} categorie",
  n_categories_one: "{{count}} categoria",
  vocabulary_categories_description:
    "Le categorie in cui ogni analisi classifica passaggi e processi. Quelle archiviate restano per le analisi passate ma non vengono usate per le nuove.",
  category_kind_step_type: "Tipi di step",
  category_kind_business_domain: "Aree aziendali",
  category_kind_process_pattern: "Schemi di processo",
  category_name: "Nome",
  category_description: "Descrizione",
  category_add: "Aggiungi categoria",
  category_archive: "Archivia",
  category_unarchive: "Ripristina",
  category_archived_badge: "archiviata",
  category_min_active: "Ogni elenco richiede almeno {{count}} categorie attive.",
  prompt_config_title: "Configurazione dei prompt",
  prompt_config_card_description: "Modifica i testi dei prompt usati da analisi e chat.",
  prompt_config_description:
    "Ogni prompt è composto da una struttura fissa con sezioni modificabili. Salvare una sezione crea una nuova versione, applicata a tutta l'azienda dalla prossima esecuzione; il ripristino riporta la sezione al testo integrato.",
  prompt_config_no_permission: "Non hai i permessi per configurare i prompt.",
  prompt_config_customized: "personalizzato",
  prompt_config_built_in: "integrato",
  prompt_config_snippet_name: "Etichetta della versione",
  prompt_config_slot_text: "Testo della sezione",
  prompt_config_company_label: "Configura i prompt per",
  prompt_config_all_companies: "Tutte le aziende (valori di sistema)",
  prompt_config_deployment_text: "personalizzazione di sistema",
  prompt_config_tab_assignments: "Assegnazioni",
  prompt_config_tab_snippets: "Snippet",
  prompt_config_option_built_in: "Testo integrato",
  prompt_config_option_inherit: "Nessuna personalizzazione aziendale",
  prompt_config_new_snippet: "Nuovo snippet",
  prompt_config_new_version: "Nuova versione",
  prompt_config_delete_snippet_hint:
    "Elimina questa versione e quelle derivate; le sezioni che le usano tornano al testo precedente",
  prompt_config_show_text: "Mostra il testo",
  prompt_config_hide_text: "Nascondi il testo",
  prompt_config_no_snippets: "Ancora nessuno snippet salvato.",
  prompt_config_version_label: "Versione",
  prompt_config_save_and_apply: "Salva e applica",
  prompt_config_apply_target: "Verrà applicata a {{target}}",
  send: "Invia",
  pause: "Metti in pausa",
  resume: "Riprendi",
  edit: "Modifica",
  delete: "Elimina",
  person: "Persona",
  people: "Persone",
  weekly: "Settimanale",
  minutes_ago: "{{count}} min fa",
  hours_ago: "{{count}} h fa",
  days_ago: "{{count}} g fa",
  custom_ellipsis: "Personalizzato…",
  analysis_ready_title: "{{count}} sessioni pronte per l’analisi",
  analysis_ready_title_one: "Sessione pronta per l’analisi",
  analysis_ready_description:
    "Caricamento completato. Analizza le tue sessioni per scoprire processi e utilizzo delle app.",
  analysis_ready_action: "Vedi le sessioni da analizzare",
  review_ready_title: "{{count}} sessioni pronte per la revisione",
  review_ready_title_one: "Sessione pronta per la revisione",
  review_recordings_title: "Sessioni in attesa della tua revisione",
  review_recordings_subtitle:
    "Nulla lascia questo computer finché non lo approvi. Rivedi gli screenshot, poi approva il caricamento o elimina la sessione.",
  review_today: "Oggi",
  review_yesterday: "Ieri",
  review_approve_all: "Approva e carica tutte ({{count}})",
  review_approved: "Sessioni approvate. Caricamento di {{count}} sessioni in corso…",
  review_approved_one: "Sessione approvata. Caricamento in corso…",
  review_deleted: "Sessione eliminata.",
  review_all_caught_up: "Tutto revisionato",
  review_details: "App e attività",
  review_approve_recording: "Approva e carica",
  review_screenshots: "Rivedi screenshot",
  review_screenshots_hint: "Vedi gli screenshot ed escludi quelli che non vuoi caricare",
  review_exclude_screenshot: "Escludi",
  review_include_screenshot: "Includi",
  review_n_excluded: "{{count}} esclusi",
  review_n_excluded_one: "{{count}} escluso",
  review_exclude_confirm_title:
    "Eliminare {{excluded}} di {{count}} screenshot prima del caricamento?",
  review_exclude_confirm_description:
    "Gli screenshot esclusi vengono eliminati definitivamente da questo computer. Il resto della sessione viene caricato.",
  review_upload_all_confirm_title: "Caricare l'intera sessione?",
  review_upload_all_confirm_description:
    "Nessuno screenshot è escluso: tutto ciò che è stato registrato in questa sessione viene caricato.",
  review_n_screenshots: "{{count}} screenshot",
  review_n_events: "{{count}} eventi",
  review_n_events_one: "{{count}} evento",
  review_n_clicks: "{{count}} clic",
  review_n_shortcuts: "{{count}} scorciatoie",
  review_n_shortcuts_one: "{{count}} scorciatoia",
  review_n_typed_chars: "{{count}} caratteri digitati",
  review_n_typed_chars_one: "{{count}} carattere digitato",
  review_apps_heading: "App e finestre",
  review_no_apps: "Nessuna attività registrata",
  review_untitled_window: "(finestra senza titolo)",
  review_more_window_titles: "+{{count}} altri",
  review_more_window_titles_one: "+{{count}} altro",
  review_excluded_apps: "App escluse",
  review_excluded_apps_total: "{{duration}} in totale",
  review_excluded_apps_hint: "Non è stato registrato nulla mentre queste app erano attive.",
  tour: tourItalian,
  watchlist: watchlistItalian,
} satisfies ClankTranslation;
